import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ACCOUNT_GROUP_ID_TOKEN, InboxService, PARTNER_ID_TOKEN } from '@galaxy/conversation/core';
import { take } from 'rxjs/operators';

@Injectable()
export class InboxGuard {
  constructor(
    private router: Router,
    private inboxService: InboxService,
    @Inject(ACCOUNT_GROUP_ID_TOKEN) readonly accountGroupId$: Observable<string>,
    @Inject(PARTNER_ID_TOKEN) readonly partnerId$: Observable<string>,
  ) {}

  async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve) => {
      // TODO: Remove access canAccess$ check here to make Inbox available globally
      combineLatest([this.inboxService.canAccess$, this.accountGroupId$])
        .pipe(take(1))
        .subscribe(([canAccess, accountGroupId]) => {
          if (canAccess) {
            return resolve(true);
          } else {
            this.router.navigateByUrl(`/account/location/${accountGroupId}/activity`);
            return resolve(false);
          }
        });
    });
  }
}
